import React from 'react'
import { clampSpreadIndex } from '../helpers/spread-index-bounds'

type UseSpreadIndexClampArgs = {
  spreadIndex: number
  maxSpreadIndex: number
  maxSpreadIndexProp: number | undefined
  safeTotalPages: number
  onSpreadIndexChange?: (index: number) => void
}

/** Clamp spread index if total page count changes. */
export function useSpreadIndexClamp({
  spreadIndex,
  maxSpreadIndex,
  maxSpreadIndexProp,
  safeTotalPages,
  onSpreadIndexChange,
}: UseSpreadIndexClampArgs): void {
  React.useEffect(() => {
    // Skip clamping until at least one source of truth has loaded — otherwise a
    // restored spread index (from localStorage) gets incorrectly reset to 0.
    if (typeof maxSpreadIndexProp !== 'number' && safeTotalPages === 0) return

    const clamped = clampSpreadIndex(spreadIndex, maxSpreadIndex)

    if (clamped !== spreadIndex && onSpreadIndexChange) {
      onSpreadIndexChange(clamped)
    }
  }, [maxSpreadIndex, maxSpreadIndexProp, safeTotalPages, spreadIndex, onSpreadIndexChange])
}
